import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=3a4d7578&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"
import style0 from "./Location.vue?vue&type=style&index=0&id=3a4d7578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d7578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4d7578')) {
      api.createRecord('3a4d7578', component.options)
    } else {
      api.reload('3a4d7578', component.options)
    }
    module.hot.accept("./Location.vue?vue&type=template&id=3a4d7578&scoped=true&", function () {
      api.rerender('3a4d7578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/Location.vue"
export default component.exports